import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "hamburger", "close"]
  static values  = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.menuTarget.classList.toggle("hidden", !this.openValue)
    if (this.hasHamburgerTarget) this.hamburgerTarget.classList.toggle("hidden", this.openValue)
    if (this.hasCloseTarget)     this.closeTarget.classList.toggle("hidden", !this.openValue)
  }

  // Close menu when clicking a link inside it
  close() {
    this.openValue = false
  }

  openInstructions(event) {
    event.preventDefault()
    this.openValue = false
    document.dispatchEvent(new CustomEvent("instructions:open"))
  }
}
